import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e5bf94e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "GraphAuto" }
const _hoisted_2 = { class: "w-full flex items-center" }
const _hoisted_3 = {
  class: "block ml-3",
  href: "/Расписание предрейсов шаблон.xlsx",
  download: "Расписание предрейсов шаблон.xlsx"
}
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.33464 17.5C2.8763 17.5 2.48408 17.3369 2.15797 17.0108C1.83186 16.6847 1.66852 16.2922 1.66797 15.8333V4.16667C1.66797 3.70833 1.8313 3.31611 2.15797 2.99C2.48464 2.66389 2.87686 2.50056 3.33464 2.5H15.0013C15.4596 2.5 15.8521 2.66333 16.1788 2.99C16.5055 3.31667 16.6685 3.70889 16.668 4.16667V5.83333H17.5013C17.7374 5.83333 17.9355 5.91333 18.0955 6.07333C18.2555 6.23333 18.3352 6.43111 18.3346 6.66667C18.3341 6.90222 18.2541 7.10028 18.0946 7.26083C17.9352 7.42139 17.7374 7.50111 17.5013 7.5H16.668V9.16667H17.5013C17.7374 9.16667 17.9355 9.24667 18.0955 9.40667C18.2555 9.56667 18.3352 9.76444 18.3346 10C18.3341 10.2356 18.2541 10.4336 18.0946 10.5942C17.9352 10.7547 17.7374 10.8344 17.5013 10.8333H16.668V12.5H17.5013C17.7374 12.5 17.9355 12.58 18.0955 12.74C18.2555 12.9 18.3352 13.0978 18.3346 13.3333C18.3341 13.5689 18.2541 13.7669 18.0946 13.9275C17.9352 14.0881 17.7374 14.1678 17.5013 14.1667H16.668V15.8333C16.668 16.2917 16.5049 16.6842 16.1788 17.0108C15.8527 17.3375 15.4602 17.5006 15.0013 17.5H3.33464ZM5.83464 14.1667H8.33464C8.57075 14.1667 8.7688 14.0867 8.9288 13.9267C9.0888 13.7667 9.16852 13.5689 9.16797 13.3333V11.6667C9.16797 11.4306 9.08797 11.2328 8.92797 11.0733C8.76797 10.9139 8.57019 10.8339 8.33464 10.8333H5.83464C5.59852 10.8333 5.40075 10.9133 5.2413 11.0733C5.08186 11.2333 5.00186 11.4311 5.0013 11.6667V13.3333C5.0013 13.5694 5.0813 13.7675 5.2413 13.9275C5.4013 14.0875 5.59908 14.1672 5.83464 14.1667ZM10.8346 8.33333H12.5013C12.7374 8.33333 12.9355 8.25333 13.0955 8.09333C13.2555 7.93333 13.3352 7.73556 13.3346 7.5V6.66667C13.3346 6.43056 13.2546 6.23278 13.0946 6.07333C12.9346 5.91389 12.7369 5.83389 12.5013 5.83333H10.8346C10.5985 5.83333 10.4007 5.91333 10.2413 6.07333C10.0819 6.23333 10.0019 6.43111 10.0013 6.66667V7.5C10.0013 7.73611 10.0813 7.93417 10.2413 8.09417C10.4013 8.25417 10.5991 8.33389 10.8346 8.33333ZM5.83464 10H8.33464C8.57075 10 8.7688 9.92 8.9288 9.76C9.0888 9.6 9.16852 9.40222 9.16797 9.16667V6.66667C9.16797 6.43056 9.08797 6.23278 8.92797 6.07333C8.76797 5.91389 8.57019 5.83389 8.33464 5.83333H5.83464C5.59852 5.83333 5.40075 5.91333 5.2413 6.07333C5.08186 6.23333 5.00186 6.43111 5.0013 6.66667V9.16667C5.0013 9.40278 5.0813 9.60083 5.2413 9.76083C5.4013 9.92083 5.59908 10.0006 5.83464 10ZM10.8346 14.1667H12.5013C12.7374 14.1667 12.9355 14.0867 13.0955 13.9267C13.2555 13.7667 13.3352 13.5689 13.3346 13.3333V10C13.3346 9.76389 13.2546 9.56611 13.0946 9.40667C12.9346 9.24722 12.7369 9.16722 12.5013 9.16667H10.8346C10.5985 9.16667 10.4007 9.24667 10.2413 9.40667C10.0819 9.56667 10.0019 9.76444 10.0013 10V13.3333C10.0013 13.5694 10.0813 13.7675 10.2413 13.9275C10.4013 14.0875 10.5991 14.1672 10.8346 14.1667Z",
    fill: "white"
  })
], -1))
const _hoisted_6 = { class: "flex items-center justify-end mt-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_pre_trip_details = _resolveComponent("pre-trip-details")!
  const _component_modal_panel = _resolveComponent("modal-panel")!
  const _component_pre_trip_transfer_modal = _resolveComponent("pre-trip-transfer-modal")!
  const _component_pre_trip_update_comment_modal = _resolveComponent("pre-trip-update-comment-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_auto_graph_filters = _resolveComponent("auto-graph-filters")!
  const _component_graph_board = _resolveComponent("graph-board")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_schedule)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Создание расписания с помощью Excel",
          class: "medium GraphAuto__modal",
          loading: _ctx.state.is_schedule_loading,
          onCancel: _ctx.toggleSchedule,
          onSubmit: _ctx.createSchedule
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_file_reader, {
                class: "w-full",
                accept: ".xlsx, .xls, .csv",
                placeholder: "Файл Excel",
                value: _ctx.state.file,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.file) = $event))
              }, null, 8, ["value"]),
              _createElementVNode("a", _hoisted_3, [
                _createVNode(_component_new_button, {
                  loading: _ctx.state.is_schedule_loading,
                  disabled: _ctx.state.is_schedule_loading,
                  class: "NewButton--medium"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Скачать шаблон ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.details_state.opened)
      ? (_openBlock(), _createBlock(_component_modal_panel, {
          key: 1,
          title: "Информация о предрейсе",
          "without-footer": "",
          "max-width": "700px",
          onCancel: _ctx.closeDetails
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pre_trip_details, {
              id: _ctx.details_state.id,
              "is-can-transfer": "",
              onTransfer: _ctx.openTransfer,
              onUpdateComment: _ctx.openUpdateComment
            }, null, 8, ["id", "onTransfer", "onUpdateComment"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.transfer_state.opened)
      ? (_openBlock(), _createBlock(_component_pre_trip_transfer_modal, {
          key: 2,
          id: _ctx.transfer_state.id,
          "date-from": _ctx.filters.dateFrom,
          "date-to": _ctx.filters.dateTo,
          onClose: _ctx.closeTransfer,
          onSuccess: _ctx.onTransferRescheduled
        }, null, 8, ["id", "date-from", "date-to", "onClose", "onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.update_comment_state.opened)
      ? (_openBlock(), _createBlock(_component_pre_trip_update_comment_modal, {
          key: 3,
          item: _ctx.update_comment_state.item,
          onClose: _ctx.closeUpdateComment,
          onSuccess: _ctx.onCommentUpdated
        }, null, 8, ["item", "onClose", "onSuccess"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_page_title, { title: "График отправок" }),
      _createVNode(_component_router_link, { to: "/tms/workplace" }, {
        default: _withCtx(() => [
          _createVNode(_component_new_button, { type: "button" }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Рабочее окно логиста ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_auto_graph_filters, {
      class: "mt-4",
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onApplyFilters,
      onReset: _ctx.onResetFilters
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_new_button, {
        loading: _ctx.state.is_schedule_loading,
        disabled: _ctx.state.is_schedule_loading,
        class: "NewButton--medium NewButton--square mr-3",
        onClick: _ctx.toggleSchedule
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Создать расписание ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      _createVNode(_component_new_button, {
        loading: _ctx.state.is_excel_loading,
        disabled: _ctx.state.is_excel_loading,
        class: "NewButton--medium NewButton--square",
        hint: "Скачать Excel",
        onClick: _ctx.downloadReport
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ]),
    _createVNode(_component_graph_board, {
      class: "mt-4",
      "date-from": _ctx.filters.dateFrom,
      "date-to": _ctx.filters.dateTo,
      loading: _ctx.state.is_loading,
      failed: _ctx.state.is_failed,
      items: _ctx.state.items,
      onOpenDetails: _ctx.openDetails,
      onOpenTransfer: _ctx.openTransfer
    }, null, 8, ["date-from", "date-to", "loading", "failed", "items", "onOpenDetails", "onOpenTransfer"])
  ]))
}